module.exports = __webpack_public_path__ + "img/document-icon-active.b3361781.svg";